import isEqual from 'lodash.isequal';

function getImageFieldNames(overlayOptions) {
  const imageFieldNames = [];
  for (const [fieldName, fieldData] of Object.entries(
    overlayOptions.dynamic_fields.data
  )) {
    if (fieldData.kind == 'IMAGE') {
      imageFieldNames.push(fieldName);
    }
  }
  return imageFieldNames;
}

/**
 * Return copy of `overlayData` with IMAGE values replaced by default values.
 *
 * This is useful as IMAGE fields may be format specific and showing any
 * 'actual' overlay_data in a preview may as such use the wrong image
 * for the previewed TVSpot. Using its default value instead may show
 * the wrong image, but everything else will be correct at least.
 */
export function replaceOverlayDataImageFieldValuesWithDefaults(
  overlayData,
  defaultOverlayData,
  overlayOptions
) {
  const resultingOverlayData = Object.assign({}, overlayData);
  for (const imageFieldName of getImageFieldNames(overlayOptions)) {
    const imageDefaultValue = defaultOverlayData[imageFieldName];
    resultingOverlayData[imageFieldName] = imageDefaultValue;
  }
  return resultingOverlayData;
}

/**
 * Return copy of `overlayData` with static_fields values replaced by given dataset.
 */
export function replaceOverlayDataStaticFieldValues(overlayData, staticFields) {
  const resultingOverlayData = Object.assign({}, overlayData);
  for (const staticFieldName of Object.keys(staticFields)) {
    const staticFieldValue = staticFields[staticFieldName];
    resultingOverlayData[staticFieldName] = staticFieldValue;
  }
  return resultingOverlayData;
}

function getOverlayDataWithoutImageFields(overlayData, overlayOptions) {
  const filteredOverlayData = Object.assign({}, overlayData);
  for (const imageFieldName of getImageFieldNames(overlayOptions)) {
    delete filteredOverlayData[imageFieldName];
  }
  return filteredOverlayData;
}

/**
 * Whether all given SpotEntry use the same overlay_data.
 *
 * Ignores IMAGE fields, as they can be format-specific and thus force
 * different values by design, which we don't want to detect as such.
 */
export function spotEntriesUseSameOverlayData(entries, overlayOptions) {
  if (!entries || !entries.length) {
    return false;
  }

  const serializedOverlayDatas = [];
  for (const entry of entries) {
    const overlayData = getOverlayDataWithoutImageFields(
      entry.overlay_data,
      overlayOptions
    );
    serializedOverlayDatas.push(JSON.stringify(overlayData));
  }

  const uniqueOverlayDatas = new Set(serializedOverlayDatas);
  return uniqueOverlayDatas.size == 1;
}



// WEBPACK FOOTER //
// ./src/mixins/overlayDataPreview.js